export const memberLedgerKinds = [
  'money',
  'deductible',
  'youmi',
  'currency',
  'oil',
  'gifts-received',
  'gifts-unconfirmed',
] as const

export type MemberLedgerKind = (typeof memberLedgerKinds)[number]

export interface MemberLedgerColumn {
  title: string
  dataIndex: string
  width?: number
}

export interface MemberLedgerConfig {
  title: string
  endpoint: string
  method: 'post' | 'oil-get'
  paginated: boolean
  columns: MemberLedgerColumn[]
}

const mobile = { title: '手机号', dataIndex: 'mobile', width: 180 }

export const memberLedgerConfigs: Record<MemberLedgerKind, MemberLedgerConfig> = {
  money: {
    title: '可提现余额明细',
    endpoint: '/admin/tbk/user/accountList',
    method: 'post',
    paginated: true,
    columns: [
      mobile,
      { title: '时间', dataIndex: 'ctime' },
      { title: '明细', dataIndex: 'content' },
      { title: '金额', dataIndex: 'money', width: 180 },
    ],
  },
  deductible: {
    title: '可抵扣余额明细',
    endpoint: '/admin/tbk/user/notMoneyList',
    method: 'post',
    paginated: true,
    columns: [
      mobile,
      { title: '时间', dataIndex: 'ctime' },
      { title: '明细', dataIndex: 'content' },
      { title: '金额', dataIndex: 'money', width: 180 },
    ],
  },
  youmi: {
    title: '优米明细',
    endpoint: '/admin/tbk/user/coinList',
    method: 'post',
    paginated: true,
    columns: [
      mobile,
      { title: '时间', dataIndex: 'mtime' },
      { title: '明细', dataIndex: 'content' },
      { title: '数量', dataIndex: 'coin', width: 180 },
    ],
  },
  currency: {
    title: '电子币明细',
    endpoint: '/admin/tbk/user/currencyList',
    method: 'post',
    paginated: true,
    columns: [
      mobile,
      { title: '时间', dataIndex: 'mtime' },
      { title: '明细', dataIndex: 'content' },
      { title: '金额', dataIndex: 'currency', width: 180 },
    ],
  },
  oil: {
    title: '加油卡余额明细',
    endpoint: '/admin/oil/order/account_detail',
    method: 'oil-get',
    paginated: true,
    columns: [
      mobile,
      { title: '时间', dataIndex: 'ctime' },
      { title: '明细', dataIndex: 'accountTypeDesDetail' },
      { title: '金额', dataIndex: 'money', width: 180 },
    ],
  },
  'gifts-received': {
    title: '已领取赠送名额明细',
    endpoint: '/admin/tbk/user/places',
    method: 'post',
    paginated: false,
    columns: [
      mobile,
      { title: '昵称', dataIndex: 'nickname' },
      { title: '商品', dataIndex: 'productName' },
      { title: '邀请人', dataIndex: 'superName' },
      { title: '申请时间', dataIndex: 'ctime' },
    ],
  },
  'gifts-unconfirmed': {
    title: '待确认赠送名额明细',
    endpoint: '/admin/tbk/user/placesNot',
    method: 'post',
    paginated: false,
    columns: [
      mobile,
      { title: '昵称', dataIndex: 'nickname' },
      { title: '商品', dataIndex: 'productName' },
      { title: '邀请人', dataIndex: 'superName' },
      { title: '申请时间', dataIndex: 'ctime' },
    ],
  },
}
